import { render, staticRenderFns } from "./ex-add.vue?vue&type=template&id=3252edc9&scoped=true&"
import script from "./ex-add.vue?vue&type=script&lang=js&"
export * from "./ex-add.vue?vue&type=script&lang=js&"
import style0 from "./ex-add.vue?vue&type=style&index=0&id=3252edc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3252edc9",
  null
  
)

export default component.exports